import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ReviewInterface } from '../../types';
import { AvatarImageComponent } from '../avatar-image/avatar-image.component';
import { RatingStarsComponent } from '../rating-stars/rating-stars.component';

@Component({
    selector: 'lib-review-item',
    standalone: true,
    imports: [CommonModule, RatingStarsComponent, AvatarImageComponent],
    templateUrl: './review-item.component.html',
    styleUrl: './review-item.component.css'
})
export class ReviewItemComponent {
    @Input() reviews: ReviewInterface[] = [];
    @Input() totalRatings: number | undefined = undefined;
    @Input() starRating: number | undefined = undefined;
    @Input() totalReviews: number | undefined = undefined;
}
